import { createApp } from 'vue'
import App from './App.vue'
import VueTyped from 'vue3-typed-js'

createApp(App)
  .use(VueTyped)
  .mount('#app')
